const testimonials = [
  {
    name: 'Kamakshi Gupta',
    location: 'Chandigarh',
    rating: 5,
    text: 'Amazing service! They came on time, paid good rates, and were very professional. Highly recommended!'
  },
  {
    name: 'Aastha Arora',
    location: 'Panchkula',
    rating: 5,
    text: 'Finally found a reliable scrap collection service. The team is honest and the process is so simple!'
  },
  {
    name: 'Bharat Pathania',
    location: 'Mohali',
    rating: 5,
    text: 'Best rates in the market and excellent customer service. Will definitely use again!'
  },
  {
    name: 'Rohan Mehta',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very smooth booking process and the pickup team arrived exactly on time.'
  },
  {
    name: 'Simran Kaur',
    location: 'Mohali',
    rating: 5,
    text: 'The team was polite, professional, and gave me a fair price for all my scrap.'
  },
  {
    name: 'Rahul Sharma',
    location: 'Panchkula',
    rating: 5,
    text: 'Excellent experience from booking to payment. Everything was handled professionally.'
  },
  {
    name: 'Neha Kapoor',
    location: 'Chandigarh',
    rating: 5,
    text: 'Quick pickup and transparent pricing. I really liked how simple the entire process was.'
  },
  {
    name: 'Ankit Verma',
    location: 'Mohali',
    rating: 5,
    text: 'Very convenient service for household scrap. The pickup was quick and hassle-free.'
  },
  {
    name: 'Ritika Sood',
    location: 'Panchkula',
    rating: 5,
    text: 'Professional staff and excellent communication. Highly satisfied with the service.'
  },
  {
    name: 'Manish Bansal',
    location: 'Chandigarh',
    rating: 5,
    text: 'Got a good rate and the payment was made promptly after collection.'
  },
  {
    name: 'Pooja Malhotra',
    location: 'Mohali',
    rating: 5,
    text: 'Booking was very easy and the collection team was friendly and punctual.'
  },
  {
    name: 'Karan Singh',
    location: 'Panchkula',
    rating: 5,
    text: 'One of the easiest scrap collection experiences I have had. Great service!'
  },
  {
    name: 'Shreya Arora',
    location: 'Chandigarh',
    rating: 5,
    text: 'The team arrived on schedule and handled everything neatly. Very professional.'
  },
  {
    name: 'Deepak Kumar',
    location: 'Mohali',
    rating: 5,
    text: 'Good rates, quick service, and very polite staff. I would definitely recommend them.'
  },
  {
    name: 'Mehak Gupta',
    location: 'Panchkula',
    rating: 5,
    text: 'A very reliable option for selling household scrap. The process was completely hassle-free.'
  },
  {
    name: 'Varun Khanna',
    location: 'Chandigarh',
    rating: 5,
    text: 'Excellent service and transparent dealing. Everything happened exactly as promised.'
  },
  {
    name: 'Nisha Thakur',
    location: 'Mohali',
    rating: 5,
    text: 'The pickup was on time and the team was very courteous. Great overall experience.'
  },
  {
    name: 'Akash Jain',
    location: 'Panchkula',
    rating: 5,
    text: 'Very efficient service. I received a fair price and quick payment.'
  },
  {
    name: 'Priya Sharma',
    location: 'Chandigarh',
    rating: 5,
    text: 'Super convenient service. No need to search for local scrap dealers anymore.'
  },
  {
    name: 'Harpreet Singh',
    location: 'Mohali',
    rating: 5,
    text: 'Professional team and smooth communication throughout the pickup.'
  },
  {
    name: 'Riya Mehta',
    location: 'Panchkula',
    rating: 5,
    text: 'Very good experience. The booking process was simple and the pickup was punctual.'
  },
  {
    name: 'Sahil Arora',
    location: 'Chandigarh',
    rating: 5,
    text: 'Good pricing and excellent service. The team handled everything efficiently.'
  },
  {
    name: 'Divya Kapoor',
    location: 'Mohali',
    rating: 5,
    text: 'Really impressed with the professionalism and quick response from the team.'
  },
  {
    name: 'Mohit Saini',
    location: 'Panchkula',
    rating: 5,
    text: 'Easy booking, timely pickup, and fair payment. Excellent service overall.'
  },
  {
    name: 'Isha Bhatia',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very convenient way to clear unwanted scrap from home. Highly recommended.'
  },
  {
    name: 'Rajiv Khurana',
    location: 'Mohali',
    rating: 5,
    text: 'The team was punctual and professional. The entire process was transparent.'
  },
  {
    name: 'Tanvi Sharma',
    location: 'Panchkula',
    rating: 5,
    text: 'Great service and very responsive staff. I will definitely book again.'
  },
  {
    name: 'Yash Gupta',
    location: 'Chandigarh',
    rating: 5,
    text: 'Everything went smoothly from booking to payment. Very satisfied.'
  },
  {
    name: 'Komal Verma',
    location: 'Mohali',
    rating: 5,
    text: 'Fair rates and excellent customer service. The pickup team was very helpful.'
  },
  {
    name: 'Abhishek Rana',
    location: 'Panchkula',
    rating: 5,
    text: 'Fast response and reliable pickup service. A great experience.'
  },
  {
    name: 'Sakshi Jain',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very professional service with clear communication and quick pickup.'
  },
  {
    name: 'Gaurav Malhotra',
    location: 'Mohali',
    rating: 5,
    text: 'The process was much easier than expected. Good rates and friendly staff.'
  },
  {
    name: 'Pallavi Sood',
    location: 'Panchkula',
    rating: 5,
    text: 'Excellent experience. The team reached on time and completed the pickup quickly.'
  },
  {
    name: 'Naveen Arora',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very reliable scrap collection service. Everything was handled professionally.'
  },
  {
    name: 'Muskan Kaur',
    location: 'Mohali',
    rating: 5,
    text: 'Simple booking and quick pickup. The staff was very polite.'
  },
  {
    name: 'Aman Deep',
    location: 'Panchkula',
    rating: 5,
    text: 'Good service and fair pricing. I am happy with the overall experience.'
  },
  {
    name: 'Radhika Mehta',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very convenient and trustworthy service. Would happily use it again.'
  },
  {
    name: 'Vikas Sharma',
    location: 'Mohali',
    rating: 5,
    text: 'Excellent pickup service and very professional team.'
  },
  {
    name: 'Anjali Kapoor',
    location: 'Panchkula',
    rating: 5,
    text: 'The entire process was quick and straightforward. Great experience.'
  },
  {
    name: 'Rajat Bansal',
    location: 'Chandigarh',
    rating: 5,
    text: 'Good rates and timely pickup. The team was very professional.'
  },
  {
    name: 'Navneet Kaur',
    location: 'Mohali',
    rating: 5,
    text: 'Very easy to book and the pickup was completed without any issues.'
  },
  {
    name: 'Kunal Verma',
    location: 'Panchkula',
    rating: 5,
    text: 'Professional staff and transparent pricing. Highly recommended.'
  },
  {
    name: 'Aditi Sharma',
    location: 'Chandigarh',
    rating: 5,
    text: 'Great service and very convenient for household scrap collection.'
  },
  {
    name: 'Rishabh Jain',
    location: 'Mohali',
    rating: 5,
    text: 'Quick response, punctual pickup, and good customer support.'
  },
  {
    name: 'Simranjeet Kaur',
    location: 'Panchkula',
    rating: 5,
    text: 'Very satisfied with the service. Everything was smooth and professional.'
  },
  {
    name: 'Arjun Mehta',
    location: 'Chandigarh',
    rating: 5,
    text: 'Fair pricing and excellent service. The team was very punctual.'
  },
  {
    name: 'Poonam Gupta',
    location: 'Mohali',
    rating: 5,
    text: 'Really convenient service and very helpful pickup staff.'
  },
  {
    name: 'Tarun Saini',
    location: 'Panchkula',
    rating: 5,
    text: 'Excellent service from start to finish. Will definitely use again.'
  },
  {
    name: 'Shivani Arora',
    location: 'Chandigarh',
    rating: 5,
    text: 'The pickup was quick and the team was very courteous.'
  },
  {
    name: 'Rohit Kapoor',
    location: 'Mohali',
    rating: 5,
    text: 'Very professional experience with good pricing and quick payment.'
  },
  {
    name: 'Preeti Sood',
    location: 'Panchkula',
    rating: 5,
    text: 'Easy booking process and reliable pickup service.'
  },
  {
    name: 'Nitin Sharma',
    location: 'Chandigarh',
    rating: 5,
    text: 'Good communication and excellent pickup service.'
  },
  {
    name: 'Jyoti Bansal',
    location: 'Mohali',
    rating: 5,
    text: 'The team was professional and gave a fair price for the scrap.'
  },
  {
    name: 'Saurabh Gupta',
    location: 'Panchkula',
    rating: 5,
    text: 'Very smooth and convenient service. Highly satisfied.'
  },
  {
    name: 'Rupali Mehta',
    location: 'Chandigarh',
    rating: 5,
    text: 'Great experience with timely pickup and professional staff.'
  },
  {
    name: 'Himanshu Arora',
    location: 'Mohali',
    rating: 5,
    text: 'Fast service and transparent dealing. Would recommend it.'
  },
  {
    name: 'Kritika Sharma',
    location: 'Panchkula',
    rating: 5,
    text: 'Very reliable and easy-to-use scrap collection service.'
  },
  {
    name: 'Ravi Kumar',
    location: 'Chandigarh',
    rating: 5,
    text: 'Good rates and quick collection. Excellent overall experience.'
  },
  {
    name: 'Sonia Kapoor',
    location: 'Mohali',
    rating: 5,
    text: 'The staff was polite and the pickup was completed quickly.'
  },
  {
    name: 'Varsha Jain',
    location: 'Panchkula',
    rating: 5,
    text: 'Very professional and convenient service. Will book again.'
  },
  {
    name: 'Amit Khanna',
    location: 'Chandigarh',
    rating: 5,
    text: 'Excellent customer service and fair scrap rates.'
  },
  {
    name: 'Harshita Verma',
    location: 'Mohali',
    rating: 5,
    text: 'Booking was simple and the team arrived on schedule.'
  },
  {
    name: 'Manpreet Singh',
    location: 'Panchkula',
    rating: 5,
    text: 'A reliable and professional scrap collection service.'
  },
  {
    name: 'Nidhi Arora',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very good experience with fast pickup and clear pricing.'
  },
  {
    name: 'Rakesh Sood',
    location: 'Mohali',
    rating: 5,
    text: 'Professional team and excellent service throughout the process.'
  },
  {
    name: 'Mansi Gupta',
    location: 'Panchkula',
    rating: 5,
    text: 'Very convenient and hassle-free scrap collection.'
  },
  {
    name: 'Amanpreet Kaur',
    location: 'Chandigarh',
    rating: 5,
    text: 'Great service and very responsive customer support.'
  },
  {
    name: 'Vivek Sharma',
    location: 'Mohali',
    rating: 5,
    text: 'Good pricing and punctual pickup. Highly recommended.'
  },
  {
    name: 'Ritu Malhotra',
    location: 'Panchkula',
    rating: 5,
    text: 'The process was quick, simple, and professionally handled.'
  },
  {
    name: 'Sandeep Verma',
    location: 'Chandigarh',
    rating: 5,
    text: 'Very satisfied with the service and the pickup team.'
  },
  {
    name: 'Kavita Sharma',
    location: 'Mohali',
    rating: 5,
    text: 'Excellent experience with fair rates and quick payment.'
  },
  {
    name: 'Rachit Gupta',
    location: 'Chandigarh',
    rating: 4,
    text: 'Good overall service and fair pricing. Pickup was slightly delayed but the team was helpful.'
  },
  {
    name: 'Shalini Arora',
    location: 'Mohali',
    rating: 4,
    text: 'Good experience and professional staff. The process could be a little faster.'
  },
  {
    name: 'Varun Sood',
    location: 'Panchkula',
    rating: 4,
    text: 'Reliable service and good rates. Overall, I was satisfied with the pickup.'
  },
  {
    name: 'Pankaj Sharma',
    location: 'Chandigarh',
    rating: 4,
    text: 'The service was good and the staff was courteous. Pickup timing can be improved.'
  },
  {
    name: 'Neelam Kaur',
    location: 'Mohali',
    rating: 4,
    text: 'Good customer service and fair pricing. Overall a positive experience.'
  },
  {
    name: 'Aarav Malhotra',
    location: 'Panchkula',
    rating: 2,
    text: 'The pickup was considerably delayed and the experience was not as smooth as expected.'
  },
  {
    name: 'Kiran Sharma',
    location: 'Chandigarh',
    rating: 2,
    text: 'The service needs improvement in communication and pickup timing.'
  }
];

export default testimonials;